module.exports = __webpack_public_path__ + "img/header-weddingRingsCarbon.3ebd715.webp";